import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import firebaseApp from "../firebaseApp";
import { getAuth } from "firebase/auth";

const useStyles = makeStyles((theme) => ({
  navButton: {
    marginLeft: 8,
    fontSize: "1rem",
  },
}));

// Configure FirebaseUI.
const uiConfig = {
  signInFlow: "popup",

  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  //signInSuccessUrl: window.location.href,
  // We will display Google and Facebook as auth providers.
  signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
  callbacks: {
    signInSuccessWithAuthResult: function (authResult, redirectUrl) {
      // no redirect
      return false;
    },
  },
};

export default function SignInScreen({ currentUser, handleClose, showLogout }) {
  const classes = useStyles();

  if (currentUser && showLogout) {
    return (
      <Button
        className={classes.navButton}
        color="primary"
        onClick={async () => {
          handleClose();
          const auth = getAuth(firebaseApp);
          await auth.signOut();
        }}
      >
        Logout
      </Button>
    );
  }

  const auth = getAuth(firebaseApp);
  return (
    <div>
      <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
    </div>
  );
}
